import { useTranslation } from 'react-i18next';
export default function ComparisonVerdict({ competitor, verdict, honestNote }) {
  const { t } = useTranslation();
  return (
    <>
      {/* Verdict section */}
      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="relative overflow-hidden border-2 border-amber-500/30 bg-gradient-to-br from-zinc-950 via-zinc-900 to-zinc-950">
          {/* Decorative corner accents */}
          <div className="absolute top-0 left-0 w-16 h-16 border-t-2 border-l-2 border-amber-500/50" aria-hidden="true" />
          <div className="absolute bottom-0 right-0 w-16 h-16 border-b-2 border-r-2 border-amber-500/50" aria-hidden="true" />

          <div className="p-8 lg:p-12">
            <div className="text-center mb-8">
              <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-4">
                // THE VERDICT
              </div>
              <h2 className="font-display text-3xl lg:text-5xl uppercase leading-[0.95] text-white">
                Max OS vs {competitor}
              </h2>
            </div>

            <div className="max-w-3xl mx-auto text-center">
              <p className="text-lg text-zinc-300 leading-relaxed mb-6">
                {verdict.summary}
              </p>

              <div className="inline-flex items-center gap-3 bg-amber-500/10 border border-amber-500/30 px-6 py-3 mb-8">
                <div className="w-8 h-8 bg-amber-500 flex items-center justify-center font-display text-black text-sm">M</div>
                <span className="text-amber-400 font-medium text-sm">{verdict.recommendation}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Honest note */}
      <section className="max-w-3xl mx-auto px-6 lg:px-12 py-4">
        <div className="border border-zinc-800 bg-zinc-950/40 p-8 text-center">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-3">{t('comparison_verdict.honest_take')}</p>
          <p className="text-zinc-300 leading-relaxed italic">&ldquo;{honestNote}&rdquo;</p>
        </div>
      </section>
    </>
  );
}
